import CheckmarkCircleIcon from "../../../../assets/svg/checkmark-circle.svg?react";

export const CheckmarkCircle = () => {
  return <CheckmarkCircleIcon />;
};
